//* Libraries imports
import { useState } from "react";

//* Service imports
import { techinicalService } from "@/features/techinicaldocument/TechinicalService";

//* Types imports
import type { ApiError } from "@/types/api";
import type {
  TechinicalDocumentResponse,
  MappingRule,
} from "@/features/techinicaldocument/types";

export const useGenerateDocument = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<TechinicalDocumentResponse | null>(null);

  const generate = async (
    id: string,
    payload: {
      mappingRules?: MappingRule[];
      clientId?: string;
      filledFormId?: string;
      replacements?: Record<string, string>;
      baseForm?: string;
    }
  ) => {
    setLoading(true);
    setError(null);
    try {
      const response = await techinicalService.generateDocument(id, payload);

      if ("code" in response && "message" in response) {
        const apiError = response as ApiError;
        throw new Error(apiError.message);
      }

      if ("data" in response) {
        setData(response.data || null);
        return response.data;
      }

      throw new Error("Resposta inesperada do servidor");
    } catch (err: any) {
      const errorMessage =
        err.message || "Ocorreu um erro ao gerar o documento";
      setError(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { generate, loading, error, data };
};
